var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5000",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33594 9.9974C3.33594 9.53716 3.70903 9.16406 4.16927 9.16406L15.8359 9.16406C16.2962 9.16406 16.6693 9.53716 16.6693 9.9974C16.6693 10.4576 16.2962 10.8307 15.8359 10.8307L4.16927 10.8307C3.70903 10.8307 3.33594 10.4576 3.33594 9.9974Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5000",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40814 3.58002C9.73358 3.25458 10.2612 3.25458 10.5867 3.58002L16.42 9.41335C16.7454 9.73878 16.7454 10.2664 16.42 10.5919L10.5867 16.4252C10.2612 16.7506 9.73358 16.7506 9.40814 16.4252C9.0827 16.0998 9.0827 15.5721 9.40814 15.2467L14.6522 10.0026L9.40814 4.75853C9.0827 4.43309 9.0827 3.90545 9.40814 3.58002Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow_right-icon.76eeacffb41bc66d6e6ac82d1868a0f8.svg";
export { ForwardRef as ReactComponent };